import * as React from "react";
import { useEffect, Fragment, SFC } from "react";
import { PageProps } from "docz";
import { useWindowSize } from "react-use";
import styled from "styled-components";

import { Sidebar, Topbar } from "@components/shared";
import { breakpoints } from "@styles/responsive";
import { Container } from "./Container";

const Wrapper = styled.div`
  flex: 1;
  margin-top: 60px;

  &.no-top-bar {
    margin-top: 0;
  }

  ${Container} {
    display: flex;
    min-height: 100%;
  }
`;

const ShowCodeContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Document = styled.div`
  margin: 0 auto;
  max-width: 1060px;
  width: 100%;

  &.has-code {
    margin-right: calc((100vw - 250px) * 0.4);
    width: calc(100vw - 250px);
  }

  ${p =>
    p.theme.mq({
      padding: ["10px 0", "35px 35px"]
    })}
`;

const DocumentContent = styled.div`
  position: relative;
  animation: 0.2s cubic-bezier(1, 0.5, 0.8, 1) doc-slide-fade;
  &.has-code {
    padding: 0 30px;
  }

  &.sm {
    width: calc(100% - 30px);
    margin: 10px 15px;
  }

  @keyframes doc-slide-fade {
    0% {
      opacity: 0.3;
      transform: translateX(10px);
    }

    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

let lastRoute = null;

export const Page: SFC<PageProps> = ({ children, doc, location }) => {
  const { parent, fullpage, route } = doc;
  const { width } = useWindowSize();
  const isAtLeastDesktop = width > breakpoints.tablet;
  const menuParent = parent || doc.name;
  const pathname = location && location.pathname;
  const hash = location && location.hash;

  if (lastRoute !== route) window.scrollTo(0, 0);
  lastRoute = route;

  return (
    <React.Fragment>
      <Topbar pathname={pathname} />
      <Wrapper>
        {!isAtLeastDesktop && (
          <Sidebar menu={menuParent} pathname={pathname} mobile />
        )}
        {fullpage ? (
          <Fragment>{children}</Fragment>
        ) : (
            <ShowCodeContainer>
              {isAtLeastDesktop && (
                <Sidebar menu={menuParent} pathname={pathname} hash={hash} />
              )}
              <Document>
                <DocumentContent className={`${isAtLeastDesktop ? "" : "sm"}`}>
                  {children}
                </DocumentContent>
              </Document>
            </ShowCodeContainer>
          )}
      </Wrapper>
    </React.Fragment>
  );
};
